import { h } from 'preact';
import { RootStore } from '../../js/stores/root.store';
type Props = {
  showRecommendation: boolean;
  canInstallIcon: boolean;
  remainingTime: number;
  styles?: h.JSX.CSSProperties;
};

export default function InformationLabel(
  { showRecommendation, canInstallIcon, remainingTime, styles }: Props,
  context: {
    translate: (
      key: string,
      params?: Record<string, string | number | undefined>
    ) => string;
  }
) {
  let content;
  let zone;

  const shouldDisplay = !RootStore.getInstance().videoStore.isVideoCompleted
    .value;

  const configStore = RootStore.getInstance().configStore;
  const brandName = configStore.config.brand && configStore.config.brand.name;
  const showCloseDelay =
    configStore.config.closeBtn && configStore.config.closeBtn.showCloseDelay;

  if (!shouldDisplay) {
    return null;
  } else if (showRecommendation) {
    zone = 'recommandation';
    content = {
      __html: context.translate('discover', {
        name: brandName
      })
    };
  } else if (canInstallIcon) {
    zone = 'add_to_bookmark';
    content = {
      __html: context.translate('click_bookmark')
    };
  } else if (showCloseDelay) {
    zone = 'wait_label';
    content = {
      __html: context.translate('wait', {
        count: Math.round(remainingTime)
      })
    };
  }

  return (
    <span style={styles}>
      <span data-zone={zone} dangerouslySetInnerHTML={content} />{' '}
    </span>
  );
}

InformationLabel.defaultProps = {
  shouldDisplay: true
};
